import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
import { Link } from 'react-router-dom'
import Search from './Search'
import UserSection from './UserSection'
import ButtonsSection from './ButtonsSection'
// import Menu from '../../assets/icons/header/menu.svg'
import CalenderIcon from '../../assets/icons/common/calender.svg'
import MenuIcon from '../../assets/icons/header/menu.svg'
import CloseIcon from '../../assets/icons/common/cancel.svg'
import UserMenu from './UserMenu'
import { Offcanvas } from 'react-bootstrap'
import Sidebar from '../sidebar/Sidebar'
import { CLASSES } from '../../assets/styles/classes'
import moment from 'moment'

function Header() {
  const [showMenu, setShowMenu] = React.useState(false)
  const [showSidebar, setShowSidebar] = React.useState(false)

  React.useEffect(() => {
    if (showMenu) {
      var dropdown = document.querySelector('.user-menu-btn')
      const handleShowMenu = (event) => {
        console.log('clicked outside user menu...')
        var isClickInside = dropdown?.contains(event.target)
        if (!isClickInside) {
          setShowMenu(false)
        }
      }
      document.addEventListener('click', handleShowMenu)
      return () => {
        document.addEventListener('click', handleShowMenu)
      }
    }
  }, [showMenu])

  return (
    <>
      <Navbar
        sticky='top'
        collapseOnSelect
        expand='lg'
        className='border-bottom-gray bg-white'
        style={{ zIndex: 99 }}
      >
        <Container fluid className='py-2 position-relative'>
          <Row className='w-100 m-0'>
            <Col className='d-flex justify-content-between align-items-center gap-3'>
              <div className='d-none d-md-block'>
                <h5>Welcome Back !</h5>
                <div className='d-flex align-items-center'>
                  <Image src={CalenderIcon} className='me-2 svg-icon' />
                  <span className='text-gray'>
                    {moment().format('DD MMM, YYYY')}
                  </span>
                </div>
              </div>
              <div
                onClick={() => setShowSidebar(true)}
                className='pointer d-block d-md-none'
                style={{ marginLeft: -5 }}
              >
                <Image height={40} src={MenuIcon} />
              </div>
              <Search />
              <div className='d-flex align-items-center gap-3'>
                <ButtonsSection />
                <UserSection
                  setShowMenu={() => {
                    // setShowMenu((x) => !x)
                  }}
                />
              </div>
            </Col>
          </Row>
          {showMenu && <UserMenu setShowMenu={setShowMenu} />}
        </Container>
      </Navbar>
      <Offcanvas
        placement='start'
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        className='bg-theme'
        style={{ maxWidth: '300px' }}
      >
        <Offcanvas.Header
          closeButton={false}
          className={CLASSES.content_center + 'black-shadow-15'}
          style={{ position: 'absolute', right: 5, top: 5, height: 40, width: 40 }}
        >
          <div onClick={() => setShowSidebar(false)} className={'pointer'}>
            <Image height={40} src={CloseIcon} />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body className='p-0'>
          <Sidebar
            setShowSidebar={() => setShowSidebar(false)}
            style={{ display: 'block', height: '100%' }}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default Header
